import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.81 7.15 12 10.05l.72 3.82a.76.76 0 0 1-.29.74.74.74 0 0 1-.45.15.76.76 0 0 1-.33-.08L8 12.89l-3.58 1.79a.81.81 0 0 1-.34.08.74.74 0 0 1-.45-.15.76.76 0 0 1-.29-.74l.73-3.82-2.86-2.9A.76.76 0 0 1 1 6.39a.74.74 0 0 1 .59-.51l3.92-.64 1.83-3.57a.44.44 0 0 1 .08-.11.64.64 0 0 1 .21-.19l.16-.07a.69.69 0 0 1 .2 0H8a.58.58 0 0 1 .19 0l.17.07a.55.55 0 0 1 .21.19.44.44 0 0 1 .08.11l1.79 3.57 3.92.64a.74.74 0 0 1 .59.51.76.76 0 0 1-.14.76Zm-7.17-5.8.16-.07-.13.05Zm.57-.07.17.07Z';
const draw24px = 'M20.54,10.76l-3.73,3.79.94,5a.76.76,0,0,1-.29.74.74.74,0,0,1-.45.15.76.76,0,0,1-.33-.08L12,18,7.31,20.34a.76.76,0,0,1-.33.08.74.74,0,0,1-.45-.15.76.76,0,0,1-.29-.74l1-5L3.47,10.76a.75.75,0,0,1,.41-1.27L9,8.65,11.33,4l0,0a.69.69,0,0,1,.28-.28l.16-.07a.75.75,0,0,1,.42,0l.16.07a.69.69,0,0,1,.28.28l0,0L15,8.65l5.11.84a.74.74,0,0,1,.59.51A.76.76,0,0,1,20.54,10.76Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const StarFilledIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'starFilled'));
StarFilledIcon.displayName = 'StarFilledIcon';
StarFilledIcon.propTypes = Icon.propTypes;
StarFilledIcon.renderIcon = props => /*#__PURE__*/React.createElement(StarFilledIcon, props);
export default StarFilledIcon;
//# sourceMappingURL=StarFilledIcon.js.map